import { render } from "./CameraLookupSubForm.vue?vue&type=template&id=670e5e26&ts=true"
import script from "./CameraLookupSubForm.vue?vue&type=script&lang=ts"
export * from "./CameraLookupSubForm.vue?vue&type=script&lang=ts"

import "./CameraLookupSubForm.vue?vue&type=style&index=0&id=670e5e26&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__